import { render, staticRenderFns } from "./PPOB.vue?vue&type=template&id=f9e607ea"
import script from "./PPOB.vue?vue&type=script&lang=js"
export * from "./PPOB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports